import React, { useEffect, useRef, useState } from "react";
import DialogWrap, { DialogWrapLogin, DialogWrapMedium } from "../../../controls/components/dialogWrap/DialogWrap";
import { ActiveType } from "../../../../models/Login";
import {
	DropdownContainerFireBase,
	DropdownContainerFireBasev2,
	DropdownHeaderFireBase,
	DropdownHeaderFireBaseDiv,
	DropdownHeaderFireBasev2,
	DropdownListContainerFireBase,
	DropdownListFireBase,
	FlagImageFireBase,
	FomrmLoginInput,
	FomrmLoginInputPhone,
	FomrmLoginInputPhoneNumberInner,
	ListItemFireBase,
	SeledctApp,
} from "../../LoginUser/styled/LoginStyles";
import {
	OrderInput,
	OrderInputPhoneNumberWrap,
	OrderInputWrap,
	OrderPageInfomationTime,
	OrderPageInfomationTimeTitle,
	OrderPageInfomationTimeWrap,
} from "../../Order/styled/OrderStyle";
import DateRangeInput, { TimeRangeInput } from "../../../controls/components/dateRangeInput/DateRangeInputOrder";
import { SelectApp } from "../../LoginUser/component/FormCreateOne";
import { PHONE_COUNTRY_CODE } from "../../LoginUser/hook/phoneCountryCode";
import { UserFormServiceButtonClose, UserFormServiceButtonCreated } from "../../MyBooking/styled/DesStyled";
import useAddUserAdmin from "../hook/AddUserAdmin";

export default function DialogAddUserAdmin(props: {
	openDialog: boolean;
	setOpenDialog: (value: boolean) => void;
	reload: () => void;
}) {
	const [name, setName] = useState("");
	const [email, setEmail] = useState("");
	const [phone, setPhone] = useState("");
	const [selectedCountryCode, setSelectedCountryCode] = useState(PHONE_COUNTRY_CODE[0].dial_code);
	const [type, setType] = useState("");
	const [pass, setPass] = useState("");
	const [rePass, setRePass] = useState("");
	const { addUserAd } = useAddUserAdmin({ reload: props.reload });

	const handleSave = async () => {
		await addUserAd(name, email, phone, pass, rePass, selectedCountryCode, type);
		props.setOpenDialog(false);
	};
	return (
		<DialogWrapMedium
			login={true}
			open={props.openDialog}
			onClose={() => {
				props.setOpenDialog(false);
			}}
			title="Add User"
			actions={
				<>
					<UserFormServiceButtonClose onClick={() => props.setOpenDialog(false)}>
						Cancel
					</UserFormServiceButtonClose>
					<UserFormServiceButtonCreated onClick={handleSave}>Save</UserFormServiceButtonCreated>
				</>
			}>
			<InputUserAdmin
				name={name}
				setName={setName}
				email={email}
				setEmail={setEmail}
				phone={phone}
				setPhone={setPhone}
				selectedCountryCode={selectedCountryCode}
				setSelectedCountryCode={setSelectedCountryCode}
				type={type}
				setType={setType}
				pass={pass}
				setPass={setPass}
				rePass={rePass}
				setRePass={setRePass}
			/>
		</DialogWrapMedium>
	);
}

export function InputUserAdmin(props: {
	name: string;
	setName: (val: string) => void;
	email: string;
	setEmail: (val: string) => void;
	phone: string;
	setPhone: (val: string) => void;
	selectedCountryCode: string;
	setSelectedCountryCode: (val: string) => void;
	type: string;
	setType: (val: string) => void;
	pass: string;
	setPass: (val: string) => void;
	rePass: string;
	setRePass: (val: string) => void;
	update?: boolean;
}) {
	return (
		<div>
			<FomrmLoginInput
				placeholder="Name"
				value={props.name}
				onChange={(e) => props.setName(e.target.value)}
			/>
			<FomrmLoginInput
				placeholder="Email"
				value={props.email}
				onChange={(e) => props.setEmail(e.target.value)}
			/>
			<FomrmLoginInput
				placeholder="Pass"
				value={props.pass}
				onChange={(e) => props.setPass(e.target.value)}
			/>
			{!props.update && (
				<FomrmLoginInput
					placeholder="RePass"
					value={props.rePass}
					onChange={(e) => props.setRePass(e.target.value)}
				/>
			)}
			<OrderInputWrap>
				<OrderInputPhoneNumberWrap>
					<FomrmLoginInputPhoneNumberInner>
						<CustomDropdown
							selectedCountryCode={props.selectedCountryCode}
							setSelectedCountryCode={props.setSelectedCountryCode}
						/>
						<FomrmLoginInputPhone
							placeholder="Phone number"
							value={props.phone}
							onChange={(e) => props.setPhone(e.target.value)}
						/>
					</FomrmLoginInputPhoneNumberInner>
					<SeledctApp>
						<SelectApp
							type={props.type}
							setType={props.setType}
						/>
					</SeledctApp>
				</OrderInputPhoneNumberWrap>
			</OrderInputWrap>
		</div>
	);
}

export function CustomDropdown(props: {
	selectedCountryCode: string;
	setSelectedCountryCode: (value: string) => void;
	isUserExist?: boolean;
}) {
	const [isOpen, setIsOpen] = useState(false);
	const selectedCountry = PHONE_COUNTRY_CODE.find((country) => country.dial_code === props.selectedCountryCode);

	const toggleDropdown = () => setIsOpen(!isOpen);
	const handleOptionClick = (dial_code: any) => {
		props.setSelectedCountryCode(dial_code);
		setIsOpen(false);
	};
	const dropdownRef = useRef<HTMLDivElement | null>(null);

	useEffect(() => {
		const handleClickOutside = (event: any) => {
			if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
				setIsOpen(false);
			}
		};

		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [dropdownRef]);

	return (
		<DropdownContainerFireBasev2 disable={props.isUserExist}>
			<DropdownHeaderFireBasev2 onClick={toggleDropdown}>
				<DropdownHeaderFireBaseDiv>
					<FlagImageFireBase
						src={selectedCountry?.image}
						alt={selectedCountry?.name}
					/>
				</DropdownHeaderFireBaseDiv>
				<i
					className="fa fa-angle-down"
					aria-hidden="true"></i>
			</DropdownHeaderFireBasev2>
			{isOpen && (
				<DropdownListContainerFireBase ref={dropdownRef}>
					<DropdownListFireBase>
						{PHONE_COUNTRY_CODE.map((country) => (
							<ListItemFireBase
								key={country.code}
								onClick={() => handleOptionClick(country.dial_code)}>
								<FlagImageFireBase
									src={country.image}
									alt={country.name}
								/>
								{country.dial_code} {country.name}
							</ListItemFireBase>
						))}
					</DropdownListFireBase>
				</DropdownListContainerFireBase>
			)}
		</DropdownContainerFireBasev2>
	);
}
